// extracted by mini-css-extract-plugin
module.exports = {"rentRoomContainer":"GoodsList_rentRoomContainer__QfBGo","operateButton":"GoodsList_operateButton__H2ZSj"};